'use client';

import { useEffect, useState } from 'react';
import { generateAvatarUrl } from '@/utils/helpers/avatarHelper';

type LabAvatarProps = {
    avatarUrl?: string;
    labId: number;
    size: number;
    breakpoints?: {
        md?: number;
        lg?: number;
        xl?: number;
    };
    className?: string;
    onClick?: () => void;
};

export default function LabAvatar({
    avatarUrl,
    labId,
    size,
    breakpoints = {},
    className = '',
    onClick,
}: LabAvatarProps) {
    const [currentSize, setCurrentSize] = useState<number>(size);

    useEffect(() => {
        const updateSize = () => {
            const width = window.innerWidth;
            if (width >= 1280 && breakpoints.xl) {
                setCurrentSize(breakpoints.xl);
            } else if (width >= 1024 && breakpoints.lg) {
                setCurrentSize(breakpoints.lg);
            } else if (width >= 768 && breakpoints.md) {
                setCurrentSize(breakpoints.md);
            } else {
                setCurrentSize(size);
            }
        };

        updateSize();
        window.addEventListener('resize', updateSize);
        return () => window.removeEventListener('resize', updateSize);
    }, [size, breakpoints]);

    const backgroundImage = avatarUrl ? `url(${avatarUrl})` : generateAvatarUrl(labId);

    return (
        <div
            className={`flex-shrink-0 ${className}`}
            onClick={onClick}
            style={{
                width: `${currentSize}px`,
                height: `${currentSize}px`,
            }}
        >
            <div
                className="w-full h-full rounded-xl"
                style={{
                    backgroundImage,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            />
        </div>
    );
}
